<template>
  <div class="GroupOverview">
    <banner2 :bannerH="h1" :bannerP="P1" :bannerImg="Img1"></banner2>


    <!-- 业务分布 -->
    <div class="distributionOfBus core_box clearfix wow animate__animated animate__fadeInUp">
      <div class="distributionOfBus_b">
        <div class="distributionOfBus_left_img">
          <!-- 图片比例4:3 -->
          <img src="@/assets/img/yewufushe.png">
        </div>
        <div class="distributionOfBus_right">
          <div class="distributionOfBus_right_text">
            <h2>业务辐射</h2>
            <p>
              杉脉科技拥有完善的产品研发，设计施工，
              销售及服务体系， 包括上海总部、国内其他多个办事处。
              持续为客户提供优质产品 及服务
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 客户 -->
    <!--    <div class="cust core_box">-->
    <!--      <ul class="cust_item">-->
    <!--        <li class="item" v-for="(item,index) in cust" :key="index">-->
    <!--          <img :src="item.img">-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->

    <!-- 资质证照 -->
<!--    <div class="qualificationCertificate wow animate__animated animate__fadeInUp">-->
<!--      <div class="qualificationCertificate_title">-->
<!--        <p>资质证照 <img src="@/assets/img/logo.png"></p>-->
<!--      </div>-->
<!--      <div class="qualification">-->
<!--        <div class="qualificationItem" v-for="(item,index) in qualificationItem" :key="index">-->
<!--          <img :src="item.licImg">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import banner2 from "../components/banner.vue";

export default {
  name: "App",
  data() {
    return {
      h1: "关于我们",
      P1: `上海杉脉电子科技发展有限公司成立于2013年，专业从事智能设备软硬件开发、设计、生产的企业，总部位于上海。
           公司具有公共安全防范设计与施工、电子与智能化专业工程、音视频集成工程等各项资质，致力于为用户提供最佳的智能化产品及系统整体解决方案。`,
      Img1: require("../assets/img/banner-bg/shanmai1.jpg"),

      qualificationItem: [
        {licImg: require("../assets/img/lic/softCertificate.png")},
        {licImg: require("../assets/img/lic/appearanceCertificate.png")},
        {licImg: require("../assets/img/lic/approvedByTheCertificate.png")},
        {licImg: require("../assets/img/lic/theBusLic.png")},
        // {licImg: require("../assets/img/lic/杉脉营业执照.png")},
        {licImg: require("../assets/img/lic/certification.png")},
        {licImg: require("../assets/img/lic/lvlCertificate.png")},
        {licImg: require("../assets/img/lic/practicalCertificate.png")},
        {licImg: require("../assets/img/lic/theConstructionIndustryCertificate.png")},
      ],
      /*cust: [
        {img: require("../assets/img/cooperation/cust/cust1.png")},
        {img: require("../assets/img/cooperation/cust/cust2.png")},
        {img: require("../assets/img/cooperation/cust/cust3.png")},
        {img: require("../assets/img/cooperation/cust/cust4.png")},
        {img: require("../assets/img/cooperation/cust/cust5.png")},
        {img: require("../assets/img/cooperation/cust/cust6.png")},
        {img: require("../assets/img/cooperation/cust/cust7.png")},
        {img: require("../assets/img/cooperation/cust/cust8.png")},
        {img: require("../assets/img/cooperation/cust/cust9.png")},
        {img: require("../assets/img/cooperation/cust/cust10.png")},
        {img: require("../assets/img/cooperation/cust/cust11.png")},
        {img: require("../assets/img/cooperation/cust/cust12.png")},
        {img: require("../assets/img/cooperation/cust/cust13.png")},
        {img: require("../assets/img/cooperation/cust/cust14.png")},
        {img: require("../assets/img/cooperation/cust/cust15.png")},
        {img: require("../assets/img/cooperation/cust/cust16.png")},
        {img: require("../assets/img/cooperation/cust/cust17.png")},
        {img: require("../assets/img/cooperation/cust/cust18.png")},
        {img: require("../assets/img/cooperation/cust/cust19.png")},
        {img: require("../assets/img/cooperation/cust/cust20.png")},
      ]*/
    };
  },
  components: {
    banner2,
  },
  created() {
    this.$nextTick(() => {
      // this.toLocal();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init()
    })
    let _this = this;
    _this.$nextTick(function () {
      window.addEventListener("scroll", _this.handleScroll);
    });
  },
  methods: {},
};
</script>

<style scoped lang="scss">

.GroupOverview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.about {
  height: 700px;
  position: relative;
  margin: 100px 0;
}

.about-bg {
  width: 1200px;
  margin: 0 auto;
  background-image: url("../assets/img/bcg-lf.png");
  border-radius: 15px;
  box-shadow: 0 6px 7px #a3a3a3;
}

.about-top {
  position: relative;
  display: flex;
}

.about-top-l {
  position: absolute;
  left: 100px;
  top: 100px;
  width: 611px;
  height: 442px;

  & > span {
    font-size: 32px;
    color: $shanMai_blue;
  }

  & > p {
    font-size: 16px;
    line-height: 40px;
  }
}

.about-top-r {
  position: absolute;
  right: 100px;
  top: 180px;

  img {
    width: 251px;
    height: 136px;
    margin-top: 60px;
  }
}

.img-yinying {
  position: absolute;
  top: -35px;
  left: -35px;
  width: 5px;
  height: 408px;
  background: rgb(42, 97, 172);
}

/* 资质证照 */
.qualificationCertificate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  //min-width: 750px;
  //background-image: url("../assets/img/yingyong_bg.png");
  background-color: white;
  overflow: hidden;
}

.qualificationCertificate_title {
  max-width: 1200px;
  margin-top: 60px;
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  line-height: 50px;
  border-bottom: 1px solid $shanMai_blue;

  p {
    padding: 30px;
    color: $shanMai_blue;

    img {
      float: right;
      width: 120px;
    }
  }
}

.qualification {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 20px;
  transition: all ease 0.2s;
}

.qualificationItem {
  overflow: hidden;
  transition: width 0.5s ease;

  &:hover {
    width: 980px;
  }

  img {
    width: 364px;
    position: relative;

    &::before {
      content: attr(content);
      position: absolute;
      inset: 0;
      transform: rotatex(180deg) translatey(15px);
      transform-origin: 50% 100%;
    }
  }
}

/*业务分布*/
.distributionOfBus {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  padding: 5rem 0;

  .distributionOfBus_b {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    @media screen and (max-width: 800px){
      .distributionOfBus_left_img {
        width: 520px !important;
      }
    }
    .distributionOfBus_left_img {
      width: 800px;
      img {
        width: 100%;
        border-radius: 1rem;
      }
    }

    .distributionOfBus_right {
      width: 400px;

      .distributionOfBus_right_text {
        width: 25rem;

        h2 {
          padding: 10px 20px;
          border-bottom: 1px solid $shanMai_blue;
          color: $shanMai_blue;
        }

        p {
          padding: 10px 20px;
        }
      }
    }
  }


}

/* 资质证明 */
.cooperationInProduct {
  width: 1200px;
  margin: 0 auto;
  background-color: white;
  //box-shadow: 0 6px 7px #a3a3a3;
  border-radius: 15px;
  margin-bottom: 100px;
  margin-top: 100px;

  h1 {
    padding: 30px;
    border-bottom: 1px solid $shanMai_blue;
    color: $shanMai_blue;

    img {
      float: right;
      width: 120px;
    }
  }
}

.cooperationInProduct_b_t {
  margin-top: 20px;
  margin-left: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #2ab05a;

  p {
    display: flex;
    align-items: center;

    img {
      width: 24px;
    }

    span {
      border-right: 2px solid #2ab05a;
      margin: 0 20px;
      height: 22px;
    }
  }
}

.cooperationInProduct_b_b {
  display: flex;
  flex-wrap: wrap;
  height: 550px;
  justify-content: space-around;
  align-content: space-evenly;
  list-style: none;

  li {
    border-radius: 5px;
    box-shadow: -1px 6px 6px #a3a3a3;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    height: 180px;

    img {
      width: 100px;
    }
  }
}

/*资质证明*/
.partners {
  width: 1200px;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 6px 7px #a3a3a3;
  //margin-bottom: 100px;
  //margin-top: 100px;

  h1 {
    padding: 30px;
    color: $shanMai_blue;
    border-bottom: 1px solid $shanMai_blue;

    img {
      float: right;
      width: 120px;
    }
  }
}

.partnersShow {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  align-items: center;
  margin-top: 50px;

  li {
    padding: 5px 10px;
  }
}

/* 我们的客户 */
.cust {
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0 6px 7px #a3a3a3;

  .cust_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    list-style: none;
    width: 90%;
    padding: 50px;
    margin: 0 auto;

    .item {
      margin-left: 2rem;
      margin-top: 2rem;
    }
  }
}


</style>
